<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row align="center" justify="center" class="grey lighten-5">
          <span class="title primary--text">Scan QR Code ini saat registrasi perangkat presensi</span>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row align="center" justify="center" class="grey lighten-5" style="height: 300px;">
          <!-- <qrcode-vue :value="value" :size="size" level="H" v-if="value"></qrcode-vue> -->
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import QrcodeVue from "qrcode.vue";
import { API } from '../../../const'
export default {
  components: {
    // QrcodeVue
  },
  activated() {
    this.value = `${API}/${this.organisasi_id ? 'orgs' : 'tenant'}/${this.organisasi_id || this.tenant_id}/devices`
  },
  data() {
    return {
      value: null,
      size: 200,
    }
  },
  computed: {},

  methods: {},
}
</script>
